angular.module('rental')
    .component('rentalResourceItems', {
        bindings: {
            resourceId: '<',
            type: '<?'
        },
        templateUrl: 'app/rental/resource/rental-resource-items.html',
        controller: function ($scope, $state, modals, toastr, $rootScope, RentalResourceConst, RentalAgreementItem, RentalAgreementService) {
            this.RentalAgreementService = RentalAgreementService
            this.$onInit = () => {
                this.filters = {
                    resourceId: this.resourceId,
                    sort: 'startDate,desc',
                }
                this.load()
            }

            this.isBeforeNow = (date) => {
                return moment(date).isBefore(moment())
            }
            $scope.$on(RentalResourceConst.eventUpdate, () => this.$onInit())

            this.load = () => {
                let filters = angular.copy(this.filters)
                this.itemsPromise = RentalAgreementItem.table(filters).$promise.then(result => this.page = result)
            }
        }
    })
